import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import { buildURLForMenuItem } from "../../utils/buildURL";
import Link from "../../utils/Link";

export const FigCaption = (item) => {
  const { image, title, link, style } = item;
  const { userLanguage } = useContext(LanguageContext);

  return (
    <div className="selected-slider__item" style={{ ...style }}>
      <div className="selected-slider__item-wrap">
        <figure>
          <img src={image && image.url} alt={text(title, userLanguage)} />
          <figcaption>
            <div className="selected-slider__title">
              {text(title, userLanguage)}
            </div>
          </figcaption>
        </figure>
        <Link
          draggable="false"
          to={buildURLForMenuItem(link)}
          className="selected-slider__link"
        ></Link>
      </div>
    </div>
  );
};
